var module = angular.module('octopusApp.accounts');

module.directive('azureServiceFabricAccountSelector', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            action: '=',
            project: '='
        },
        templateUrl: 'areas/accounts/views/azure_service_fabric_account_selector.html'
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/directives/azure_service_fabric_account_selector.js
// module id = 22117288808933
// module chunks = 1